import { Injectable } from "@angular/core";
import Swal from 'sweetalert2';
@Injectable({
    providedIn: 'root',
})
export class SweetAltert2Service {
    constructor() { }
    success(Title: string, Message: string) {

        Swal.fire({
            html: `
                <div class="flex items-center bg-[#d5f4fc] p-2 pl-5 rounded-t-3xl">
                    <i class="pi pi-check text-[#578d5f]"></i>
                    <h2 class="text-lg font-semibold text-[#578d5f] ml-2 mt-0 mb-0">${Title}</h2>
                </div>
                <div class="p-4">
                    <p class="text-sm text-gray-600">${Message}</p>
                </div>
            `,
            customClass: {
                container: 'swal2-container',
                popup: 'rounded-t-3xl rounded-b-none p-0 w-[550px]',
                htmlContainer: 'p-0',
            },
            showCloseButton: true,
            showConfirmButton: false,
        });
    }
    error(Title: string, Message: string) {
        Swal.fire({
            html: `
                <div class="flex items-center bg-[#d5f4fc] p-2 pl-5 rounded-t-3xl">
                    <i class="pi pi-times text-[#b32a2a]"></i>
                    <h2 class="text-lg font-semibold text-[#b32a2a] ml-2 mt-0 mb-0">${Title}</h2>
                </div>
                <div class="p-4">
                    <p class="text-sm text-gray-600">${Message}</p>
                </div>
            `,
            customClass: {
                container: 'swal2-container',
                popup: 'rounded-t-3xl rounded-b-none p-0 w-[550px]',
                htmlContainer: 'p-0',
            },
            showCloseButton: true,
            showConfirmButton: false,
        });
    }
    warning(Title: string, Message: string) {
        Swal.fire({
            customClass: { container: 'swal2-container' },
            icon: 'warning',
            title: Title,
            text: Message,
        });
    }
    confirm(Title: string, Message: string) {
        return Swal.fire({
            html: `
                <div class="flex items-center bg-[#d5f4fc] p-2 pl-5 rounded-t-3xl">
                    <i class="pi pi-exclamation-circle text-[#f8bb86]"></i>
                    <h2 class="text-lg font-semibold text-[#f8bb86] ml-2 mt-0 mb-0">${Title}</h2>
                </div>
                <div class="p-4">
                    <p class="text-sm text-gray-600">${Message}</p>
                </div>
            `,
            customClass: {
                container: 'swal2-container',
                popup: 'rounded-t-3xl rounded-b-none p-0 w-[550px]',
                htmlContainer: 'p-0',
            },
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'No',
            confirmButtonText: 'Si',
        });
    }
}
